export default __webpack_public_path__ + "static/media/birdAnimation.71b77050.svg";